module.exports = __webpack_public_path__ + "static/media/backgroundError.d3266e26.svg";